import { Plus } from 'phosphor-react'
import { useCallback, useEffect, useState } from 'react'
import { ContentLoading } from '../../../../components/ContentLoading'
import apinode from '../../../../services/apinode'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import { toast } from 'react-toastify'
import Navbar from '../../../../components/navbar/navbar'

const IconEdit = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
)

const IconTrash = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14H6L5 6" />
    <path d="M10 11v6M14 11v6M9 6V4h6v2" />
  </svg>
)

const emptyForm = { nome: '', tipo: 'S', cor: '#4eba8a' }

export function LojaStatus() {
  const [activeTab, setActiveTab] = useState('S')

  const [statusList, setStatusList] = useState([])
  const [substatusList, setSubstatusList] = useState([])

  const [modalOpen, setModalOpen] = useState(false)
  const [form, setForm] = useState(emptyForm)
  const [editId, setEditId] = useState(null)

  const [isFetchLoading, setIsFetchLoading] = useState(true)
  const [isUpdateLoading, setIsUpdateLoading] = useState(false)
  const [isDeleteLoading, setIsDeleteLoading] = useState({})

  const currentList = activeTab === 'S' ? statusList : substatusList
  const setCurrentList = activeTab === 'S' ? setStatusList : setSubstatusList

  const openNew = () => {
    setForm({ ...emptyForm, tipo: activeTab })
    setEditId(null)
    setModalOpen(true)
  }

  const openEdit = (item) => {
    setForm({ nome: item.nome, tipo: item.tipo, cor: item.cor })
    setEditId(item.id)
    setModalOpen(true)
  }

  const handleDelete = async (id, index) => {
    if (window.confirm('Você deseja deletar?')) {
      try {
        setIsDeleteLoading((prevState) => ({
          ...prevState,
          [index]: true,
        }))

        await apinode.delete(`/loja/status/${id}/${localStorage.idconta}`)

        await fetchData()

        toast.success('Deletado com sucesso')
      } catch (err) {
        sendErrorApiMessage(err, 'Erro ao deletar')
      } finally {
        setIsDeleteLoading((prevState) => ({
          ...prevState,
          [index]: false,
        }))
      }
    }
  }

  const handleSave = async () => {
    try {
      setIsUpdateLoading(true)

      const { nome, tipo, cor } = form

      if (editId !== null) {
        await apinode.put(`/loja/status/${editId}/${localStorage.idconta}`, {
          nome,
          tipo,
          cor,
        })
      } else {
        await apinode.post(`/loja/status/${localStorage.idconta}`, {
          nome,
          tipo,
          cor,
        })
      }

      toast.success('A operação foi realizada com sucesso')
      await fetchData()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao realizar a operação')
    } finally {
      setIsUpdateLoading(false)
      setModalOpen(false)
    }
  }

  const handleHexInput = (val) => {
    setForm((f) => ({ ...f, cor: val }))
  }

  const fetchData = useCallback(async () => {
    try {
      setIsFetchLoading(true)

      const response = await apinode.get(
        `/loja/status/${localStorage.idconta}?tipo=${activeTab}`,
      )

      setCurrentList(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar informações')
    } finally {
      setIsFetchLoading(false)
    }
  }, [activeTab, setCurrentList])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return (
    <>
      <Navbar disableExtraDiv />

      <div
        className="mt-page"
        style={{
          display: 'flex',
          minHeight: '100vh',
          background: '#f5f4f0',
          fontSize: 14,
          flex: 1,
        }}
      >
        {/* Main */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <ContentLoading
            isLoading={isFetchLoading}
            loadingText="Carregando status..."
          >
            <div style={{ padding: 28, flex: 1 }}>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 600,
                  color: '#1a1a1a',
                  marginBottom: 4,
                }}
              >
                Status &amp; Substatus
              </div>

              <div style={{ fontSize: 13, color: '#888', marginBottom: 20 }}>
                Gerencie os status dos pedidos e substatus dos produtos.
              </div>

              {/* Tabs */}
              <div style={{ display: 'flex', gap: 10, marginBottom: 24 }}>
                {[
                  { label: 'Status', value: 'S' },
                  { label: 'Subtatus', value: 'U' },
                ].map((tab) => (
                  <button
                    key={tab.value}
                    onClick={() => setActiveTab(tab.value)}
                    style={{
                      margin: 0,
                      padding: '7px 18px',
                      borderRadius: 20,
                      fontSize: 13,
                      fontWeight: 500,
                      cursor: 'pointer',
                      border: 'none',
                      background:
                        activeTab === tab.value ? '#2d2d2d' : '#e8e6e0',
                      color: activeTab === tab.value ? '#f0c040' : '#555',
                      transition: 'all 0.15s',
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* Toolbar */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginBottom: 16,
                }}
              >
                <button
                  onClick={openNew}
                  style={{
                    background: '#c8a030',
                    color: '#fff',
                    border: 'none',
                    padding: '9px 18px',
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                  }}
                >
                  <Plus />
                  Novo {activeTab === 'S' ? 'Status' : 'Substatus'}
                </button>
              </div>

              {/* Table */}
              <div
                style={{
                  background: '#fff',
                  borderRadius: 10,
                  border: '1px solid #e8e6e0',
                  overflow: 'hidden',
                }}
              >
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f8f7f3' }}>
                      {['Nome', 'Cor', 'Ações'].map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: '11px 20px',
                            textAlign: 'left',
                            fontSize: 11,
                            fontWeight: 600,
                            color: '#999',
                            letterSpacing: '0.8px',
                            textTransform: 'uppercase',
                            borderBottom: '1px solid #e8e6e0',
                            background: 'white',
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {currentList.map((item, index) => (
                      <tr
                        key={item.id}
                        style={{
                          borderBottom:
                            index < currentList.length - 1
                              ? '1px solid #f0ede8'
                              : 'none',
                        }}
                      >
                        <td
                          style={{
                            padding: '14px 20px',
                            color: '#2a2a2a',
                            fontSize: 13,
                            fontWeight: 500,
                          }}
                        >
                          {item.nome}
                        </td>
                        <td style={{ padding: '14px 20px' }}>
                          <span
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 8,
                              fontSize: 12,
                              color: '#555',
                            }}
                          >
                            <span
                              style={{
                                width: 13,
                                height: 13,
                                borderRadius: '50%',
                                background: item.cor,
                                display: 'inline-block',
                              }}
                            />
                            {item.cor}
                          </span>
                        </td>
                        <td style={{ padding: '14px 20px' }}>
                          <div style={{ display: 'flex', gap: 6 }}>
                            <button
                              onClick={() => openEdit(item)}
                              style={{
                                margin: 0,
                                borderRadius: 7,
                                border: 'none',
                                cursor: 'pointer',
                                background: '#f0ede8',
                                color: '#444',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <IconEdit />
                            </button>

                            <button
                              onClick={() => handleDelete(item.id, index)}
                              style={{
                                margin: 0,
                                borderRadius: 7,
                                border: 'none',
                                cursor: 'pointer',
                                background: '#fee2e2',
                                color: '#dc2626',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              {isDeleteLoading[index] ? (
                                <CustomSpinner
                                  size={14}
                                  color="#dc2626"
                                />
                              ) : (
                                <IconTrash />
                              )}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {currentList.length === 0 && (
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            padding: '32px 20px',
                            textAlign: 'center',
                            color: '#aaa',
                            fontSize: 13,
                          }}
                        >
                          Nenhum item cadastrado.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </ContentLoading>
        </div>

        {/* Modal Overlay */}
        {modalOpen && (
          <div
            onClick={(e) => {
              if (e.target === e.currentTarget) setModalOpen(false)
            }}
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.35)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 100,
            }}
          >
            <div
              style={{
                background: '#fff',
                borderRadius: 12,
                width: 440,
                padding: 28,
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 24,
                }}
              >
                <span
                  style={{ fontSize: 17, fontWeight: 600, color: '#1a1a1a' }}
                >
                  {editId ? 'Editar' : 'Novo'}{' '}
                  {form.tipo === 'S' ? 'Status' : 'Substatus'}
                </span>
                <button
                  onClick={() => setModalOpen(false)}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 7,
                    border: 'none',
                    background: '#f0ede8',
                    color: '#555',
                    cursor: 'pointer',
                    fontSize: 18,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  ×
                </button>
              </div>

              {/* Nome */}
              <div style={{ marginBottom: 18 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    letterSpacing: '0.8px',
                    color: '#888',
                    textTransform: 'uppercase',
                    marginBottom: 7,
                  }}
                >
                  Nome
                </div>

                <input
                  type="text"
                  placeholder="Nome do status"
                  value={form.nome}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, nome: e.target.value }))
                  }
                  style={{
                    width: '100%',
                    padding: '9px 14px',
                    border: '1px solid #ddd',
                    borderRadius: 8,
                    fontSize: 13,
                    color: '#1a1a1a',
                    background: '#fafaf8',
                    outline: 'none',
                    boxSizing: 'border-box',
                  }}
                />
              </div>

              {/* Tipo */}
              <div style={{ marginBottom: 18 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    letterSpacing: '0.8px',
                    color: '#888',
                    textTransform: 'uppercase',
                    marginBottom: 7,
                  }}
                >
                  Tipo
                </div>

                <select
                  value={form.tipo}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, tipo: e.target.value }))
                  }
                  style={{
                    width: '100%',
                    padding: '9px 14px',
                    border: '1px solid #ddd',
                    borderRadius: 8,
                    fontSize: 13,
                    color: '#1a1a1a',
                    background: '#fafaf8',
                    outline: 'none',
                    cursor: 'pointer',
                    boxSizing: 'border-box',
                  }}
                >
                  <option value="S">Status</option>
                  <option value="U">Substatus</option>
                </select>
              </div>

              {/* Cor */}
              <div style={{ marginBottom: 24 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    letterSpacing: '0.8px',
                    color: '#888',
                    textTransform: 'uppercase',
                    marginBottom: 7,
                  }}
                >
                  Cor
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <input
                    type="color"
                    value={form.cor}
                    onChange={(e) =>
                      setForm((f) => ({ ...f, cor: e.target.value }))
                    }
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 8,
                      border: '1px solid #ddd',
                      cursor: 'pointer',
                      padding: 2,
                      background: 'none',
                    }}
                  />

                  <input
                    type="text"
                    value={form.cor}
                    onChange={(e) => handleHexInput(e.target.value)}
                    style={{
                      flex: 1,
                      padding: '9px 14px',
                      border: '1px solid #ddd',
                      borderRadius: 8,
                      fontSize: 13,
                      color: '#1a1a1a',
                      background: '#fafaf8',
                      outline: 'none',
                    }}
                  />

                  <div
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: '50%',
                      background: form.cor,
                      border: '2px solid #e0e0e0',
                      flexShrink: 0,
                    }}
                  />
                </div>
              </div>

              {/* Footer */}
              <div
                style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}
              >
                <button
                  onClick={() => setModalOpen(false)}
                  style={{
                    background: 'transparent',
                    border: '1px solid #ddd',
                    color: '#555',
                    padding: '9px 20px',
                    borderRadius: 8,
                    fontSize: 13,
                    cursor: 'pointer',
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={handleSave}
                  disabled={!form.nome.trim() || !form.cor.trim()}
                  style={{
                    background: '#c8a030',
                    color: '#fff',
                    border: 'none',
                    padding: '9px 22px',
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                >
                  {isUpdateLoading ? <CustomSpinner size={13} /> : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
